var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SectionList", {
        attrs: {
          title: "International Codes (I-Codes) and Supplements",
          icon: "mdi-web",
          items: _vm.iCodeCategories,
        },
      }),
      _vm._v(" "),
      _c("SectionList", {
        attrs: {
          title: "Codes by Location",
          icon: "mdi-map-marker-outline",
          items: _vm.locationCategories,
        },
      }),
      _vm._v(" "),
      _c("SectionList", {
        attrs: {
          title: "Standards, Topics and More",
          icon: "mdi-bank-outline",
          items: _vm.moreCategories,
        },
      }),
      _vm._v(" "),
      _c("SectionList", {
        attrs: {
          title: "Recently Added Titles",
          icon: "mdi-bullhorn-outline",
          items: _vm.recentlyAddedTitles,
          hideDivider: true,
          displayTitlesView: true,
          loadingTitles: _vm.loadingTitles,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }